//* Import library from react-router-dom

import { Link } from "react-router-dom";
//* Import library from react-icons
import { FaListAlt } from "react-icons/fa";

//* Import library from react-bootstrap
import { Button } from "react-bootstrap"; 

//* Import Component from base
import Search from "../base/Search";
import { Icon } from "../../components/common/Icon";

var pesquisarTimeout: any = null;

export function Searchbar(props: {
  search_text: any;
  onSearchButtonClick: () => void;
  button_text?: any;
  button_link?: any;
  component?: any;
  search_input_value: any;
  onChangeSearchInput: (value: any) => void;
  onClickButton?: any;
  hide_btn?: any;
  additionalFilters?: React.ReactNode;
  enableSelection?: boolean; 
  customButton?: React.ReactNode;
  selectedItemsCount?: number;
}) {
  return (
    <div className="container-fluid p-0">
      <div className="row g-3 mb-4 align-items-center">
        <div className="col-12 col-md d-flex align-items-center">
          {props.search_text !== undefined && (
            <Search
              inputValue={props.search_input_value}
              placeholder={props.search_text}
              ValueChange={(value: any) => {
                if (value === undefined) {
                  return undefined;
                }
                props.onChangeSearchInput(value);
                clearTimeout(pesquisarTimeout);
                pesquisarTimeout = setTimeout(() => {
                  props.onSearchButtonClick();
                }, 500);
              }}
              className="flex-grow-1"
            />
          )}
          {/* Filtros Adicionais */}
          {props.additionalFilters && (
            <div className="ms-3">{props.additionalFilters}</div>
          )}
        </div>
        <div className="col-12 col-md-auto d-flex justify-content-md-end align-items-center">
          {/* Renderiza o customButton se fornecido */}
          {props.customButton ? (
            <div>{props.customButton}</div>
          ) : (
            <>
              {!props.hide_btn &&
                props.button_text !== undefined &&
                props.button_text && (
                  <Link to={props.button_link} className="text-decoration-none">                    <Button
                      variant="success"
                      className="d-flex align-items-center"
                    >
                      <Icon icon={FaListAlt} className="me-2" />
                      <span>{props.button_text}</span>
                    </Button>
                  </Link>
                )}
              {props.onClickButton !== undefined && props.button_text && (
                <Button
                  onClick={(e: any) => {
                    e.preventDefault();
                    props.onClickButton();
                  }}
                  variant="success"
                  className="d-flex align-items-center ms-2"
                >
                  <Icon icon={FaListAlt} className="me-2" />
                  <span>{props.button_text}</span>
                </Button>
              )}
              {props.component && (
                <div className="mt-2 mt-md-0">{props.component}</div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
